import { defineStore } from "pinia";

export const useNotificationStore = defineStore("notification", {
  state: () => {
    return {
      notifications: [],
      disabledErrorRoutes: [
        {
          path: "/desktop/app-user/init",
          statusCode: 403,
        },
        {
          path: "/desktop/app-user/init",
          statusCode: 409,
        },
        {
          path: "/desktop/app-user/init",
          statusCode: 412,
        },
        {
          path: "/private/competitive-challenge/team/join",
          statusCode: 409,
        },
        {
          path: "/private/competitive-challenge/team/create",
          statusCode: 412,
        },
        {
          path: "/private/app-user/delete",
          statusCode: null,
        },
        {
          path: "/external/sbk/register-new",
          statusCode: 400,
        },
        {
          path: "/external/sbk/register-existing",
          statusCode: 400,
        },
        {
          path: "/external/sbk/activate",
          statusCode: 426,
        },
        {
          path: "/private/app-user/password/change",
          statusCode: 412,
        },
      ],
    };
  },
  actions: {
    addNotification(id, url, title, message, isError = true) {
      // Prevent multiple error notifications for same request
      const containsErrorForUrl = this.notifications.find(
        (notification) => (notification.url = url)
      );

      if (!containsErrorForUrl || url === null) {
        this.notifications.push({
          id,
          url,
          title,
          message,
          isError,
        });
      }
    },
    removeNotification(id) {
      this.notifications = this.notifications.filter(
        (notification) => notification.id !== id
      );
    },
    showErrorForRoute(error) {
      let allowed = true;
      this.disabledErrorRoutes.map((disabledErrorRoute) => {
        if (error.config && error.config.url === disabledErrorRoute.path) {
          if (
            disabledErrorRoute.statusCode !== null &&
            disabledErrorRoute.statusCode !== error.response.status
          ) {
            return disabledErrorRoute;
          }

          allowed = false;
        }
      });

      return allowed;
    },
  },
  getters: {
    getNotifications(state) {
      return state.notifications;
    },
  },
});
